import React, { useState } from 'react';

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'te', label: 'తెలుగు' },
  { code: 'ta', label: 'தமிழ்' },
  { code: 'kn', label: 'ಕನ್ನಡ' },
  { code: 'ml', label: 'മലയാളം' },
  { code: 'mr', label: 'मराठी' },
  { code: 'gu', label: 'ગુજરાતી' },
  { code: 'bn', label: 'বাংলা' },
  { code: 'pa', label: 'ਪੰਜਾਬੀ' },
  { code: 'fr', label: 'Français' },
  { code: 'de', label: 'Deutsch' },
  { code: 'pt', label: 'Português' },
  { code: 'zh-CN', label: '中文' },
  { code: 'ja', label: '日本語' },
  { code: 'ko', label: '한국어' },
  { code: 'ar', label: 'العربية' },
  { code: 'ru', label: 'Русский' },
  { code: 'vi', label: 'Tiếng Việt' },
  { code: 'th', label: 'ไทย' },
  { code: 'id', label: 'Bahasa' },
];

function triggerGoogleTranslate(langCode) {
  // Store selection in localStorage for reliable detection after reload
  localStorage.setItem('belong_lang', langCode);
  
  if (langCode === 'en') {
    // Reset to English
    document.cookie = 'googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.ourbelong.com';
    document.cookie = 'googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=ourbelong.com';
    localStorage.removeItem('belong_lang');
    window.location.reload();
    return;
  }
  document.cookie = `googtrans=/en/${langCode}; path=/;`;
  document.cookie = `googtrans=/en/${langCode}; path=/; domain=.ourbelong.com`;
  window.location.reload();
}

function LanguageSwitcher() {
  const [open, setOpen] = useState(false);

  // Detect current language from localStorage (most reliable after reload)
  const currentLang = localStorage.getItem('belong_lang') || 'en';
  const currentLabel = LANGUAGES.find(l => l.code === currentLang)?.label || 'English';

  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={() => setOpen(!open)}
        style={{
          display: 'flex', alignItems: 'center', gap: '4px',
          background: 'none', border: '1px solid #e5e7eb', borderRadius: '6px',
          padding: '5px 10px', fontSize: '13px', cursor: 'pointer',
          color: '#4b5563', fontWeight: 500
        }}
        aria-label="Change language"
      >
        🌐 {currentLabel} ▾
      </button>

      {open && (
        <>
          <div
            style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 999 }}
            onClick={() => setOpen(false)}
          />
          <div style={{
            position: 'absolute', top: '100%', right: 0, marginTop: '4px',
            background: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)', zIndex: 1000,
            maxHeight: '300px', overflowY: 'auto', width: '160px'
          }}>
            {LANGUAGES.map(lang => (
              <button
                key={lang.code}
                onClick={() => { triggerGoogleTranslate(lang.code); setOpen(false); }}
                style={{
                  display: 'block', width: '100%', textAlign: 'left',
                  padding: '8px 14px', border: 'none', background: lang.code === currentLang ? '#f3f0ff' : 'none',
                  cursor: 'pointer', fontSize: '13px', color: '#374151',
                  fontWeight: lang.code === currentLang ? 600 : 400
                }}
                onMouseOver={(e) => e.currentTarget.style.background = '#f9fafb'}
                onMouseOut={(e) => e.currentTarget.style.background = lang.code === currentLang ? '#f3f0ff' : 'transparent'}
              >
                {lang.label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default LanguageSwitcher;
